<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">
                        La nostra innovativa didattica in modalità e-learning è progettata per offrire un'apprendimento coinvolgente e flessibile. Con corsi accessibili da qualsiasi luogo e dispositivi vari, gli studenti possono imparare a proprio ritmo
                    </p>
                    <ul class="social-link d-none">
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                    <div class="row pt-3">
                        <div class="col-12 p-0" align="left">
                            <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://iusekr.discentya.it/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://iusekr.discentya.it/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Via Eugubina, 40<br>06081 Assisi (PG) </li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390754650024">Telefono: (+39) 075-4650024</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@mastereprofessioni.it">info@mastereprofessioni.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390754650024">Lunedì-Venerdì: 09:00÷18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 Master&Professioni - realizzato da <a target="_blank" style="color: #C26EBA;" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2 d-none">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
